<template>
    <div class="view-preview-panel">
        <ul class="nav nav-pills flex-row flex-wrap justify-content-around p-2">
            <li class="nav-item">
                <a class="nav-link btn btn-dark" href="#" :class="{ active: activePreview == 'preview-symbol' }" @click="changePreview('preview-symbol')">Symbol</a>
            </li>
            <li class="nav-item">
                <a class="nav-link btn btn-dark" href="#" :class="{ active: activePreview == 'preview-footprint' }" @click="changePreview('preview-footprint')">Footprint</a>
            </li>
            <li class="nav-item" v-if="previewData.threed_content != undefined && previewData.threed_content.has_3d">
                <a class="nav-link btn btn-dark" href="#" :class="{ active: activePreview == 'preview-3d-model' }" @click="changePreview('preview-3d-model')">3D Model</a>
            </li>
        </ul>
        <div class="d-flex flex-row flex-wrap justify-content-around pl-2 pr-2">
            <div id="preview-symbol" class="preview-pane flex-even p-2" :class="{ active: activePreview == 'preview-symbol' }">
                <h2 class="frut-55-roman preview-title text-center">
                    Symbol
                </h2>
                <PreviewSVG :svgContent="previewData.symbol_preview" :defaultText="'No Symbol Available'" :requestPrompt="requestPrompt" @openRequest="request" @previewChanged="changed"></PreviewSVG>
            </div>
            <div id="preview-footprint" class="preview-pane flex-even p-2" :class="{ active: activePreview == 'preview-footprint' }">
                <h2 class="frut-55-roman preview-title text-center">
                    Footprint
                </h2>
                <PreviewSVG :svgContent="previewData.footprint_preview" :defaultText="'No Footprint Available'" :requestPrompt="requestPrompt" @openRequest="request" @previewChanged="changed"></PreviewSVG>
            </div>
            <div id="preview-3d-model" v-if="previewData.threed_content != undefined &&previewData.threed_content.has_3d" class="preview-pane flex-even p-2" :class="{ active: activePreview == 'preview-3d-model' }">
                <h2 class="frut-55-roman preview-title text-center">
                    3D Model
                </h2>
                <Preview3d :url="previewData.threed_content.url" :defaultText="'No 3D Model Available'" :requestPrompt="requestPrompt" @openRequest="request"></Preview3d>
            </div>
        </div>
        <div id="symbol-view-tooltip" class="d-none">
            <h4>Symbol Views</h4>
            <h6>(not all views will be available for every part)</h6>
            <p align="left"><b>Normal:</b> Standard and most popular representation of schematic symbol</p>
            <p align="left"><b>ALT_1 (IEEE view):</b> Symbol representation in a way that is more graphical in explaining what the purpose of each pin is.   For connectors and most discretes (as we use these views) it is simply an alternate view for people to use depending on the situation.  For instance connectors can be generally an input, an output or neither.  Resistors can be vertical or horizontal.</p>
            <p align="left"><b>ALT_2 (demorgan):</b> Demorgan is a name for an equivalent Gate structure. so for instance an AND gate and an OR gate can be represented by its Demorgan equivalent of a NOR gate.</p>
        </div>

        <div id="symbol-name-tooltip" class="d-none">
            <p align="left">Sometimes a device is fractured into multiple symbols (often for high pin count parts). If that is the case, you can preview the different symbols that make up the device by selecting them in this drop down.</p>
        </div>

        <div id="footprint-view-tooltip" class="d-none">
            <h4>Footprint Views</h4>
            <h6>(not all views will be available for every part)</h6>
            <p align="left"><b>Basic:</b> Our standard footprint view showing, contact area, pin number, top, top assembly</p>
            <p align="left"><b>Detailed:</b> Additional info to help you evaluate the part and the footprint including: dimension, silkscreen, soldermask, and solderpaste</p>
            <p align="left"><b>PinDetail:</b> Highlights the pin to pad contact area dimensions</p>
        </div>

        <div id="footprint-name-tooltip" class="d-none">
            <p align="left">Displays min/typ/max pad sizes for footprint per IPC specification (not all sizes will be available for every part)</p>
        </div>
    </div>
</template>

<script>
    import PreviewSVG from './PreviewSVG.vue';
    import Preview3d from './Preview3d.vue';
    import $ from 'jquery';
    import svg_pan_zoom from 'svg-pan-zoom';

    export default {
        name: 'preview-panel',
        emits: ['openRequest', 'previewChanged'],
        props: {
            previewData: {
                type: Object,
                default: () => {
                    return {
                        threed_content: {
                            has_3d: false,
                            part_unique_id: "",
                            url: ""
                        },
                        symbol_preview: {},
                        footprint_preview: {}
                    }
                }
            },
            requestPrompt: {
                type: Boolean,
                defaul: () => {
                    return false
                }
            }
        },
        data() {
            return {
                activePreview: "preview-symbol"
            };
        },
        components: {
            PreviewSVG,
            Preview3d
        },
        methods: {
            changePreview: function (newPreview) {
                this.activePreview = newPreview;
                this.$nextTick(() => {
                    var svgChildren = $('.zoomable_svg:not(:has(.svg-pan-zoom_viewport))')
                    for (var i = 0; svgChildren && i < svgChildren.length; i++) {
                        var svgElement = svgChildren[i];
                        this.svgSetup(svgElement);
                    }
                });
            },
            svgSetup: function (svgElement) {
                if (
                    $(svgElement).is(":visible")
                    && navigator.userAgent.indexOf('Edge') < 0
                ) {
                    var svgPan = svg_pan_zoom(svgElement, {
                        viewportSelector: '.zoom_group',
                        zoomEnabled: true,
                        panEnabled: true,
                        zoomScaleSensitivity: 0.25,
                        controlIconsEnabled: true,
                        fit: true,
                        center: true,
                        minZoom: 0.25,
                        maxZoom: 10
                    });

                    svgPan.resize();
                    svgPan.fit();
                    svgPan.center();
                }
            },
            request: function () {
                this.$emit('openRequest');
            },
            changed: function () {
                this.$emit('previewChanged');
            }
        },
        watch: {
            previewData: {
                deep: true,
                handler(newPreview, oldPreview) {
                    if (newPreview.manufacturerPartNumber != oldPreview.manufacturerPartNumber ||
                        newPreview.manufacturerName != oldPreview.manufacturerName) {
                        this.changePreview('preview-symbol');
                    }
                }
            }
        },
        mounted() {
            $('.view-preview-panel').on({
                mouseenter: function () {
                    var pin = $(this).data('pin_bounding_rect');
                    $("[data-pin_number='" + pin + "']").toggleClass("pin_hover");
                },
                mouseleave: function () {
                    var pin = $(this).data('pin_bounding_rect');
                    $("[data-pin_number='" + pin + "']").toggleClass("pin_hover");
                }
            }, '.pin');

            $('.view-preview-panel').on({
                mouseenter: function () {
                    var pin = $(this).data('pin_bounding_rect');
                    $("[data-pin_number='" + pin + "']").toggleClass("mechanical_pin_hover");
                },
                mouseleave: function () {
                    var pin = $(this).data('pin_bounding_rect');
                    $("[data-pin_number='" + pin + "']").toggleClass("mechanical_pin_hover");
                }
            }, '.mechanical-pin');

            $(document).resize(function () {
                var svgChildren = $('.zoomable_svg:not(:has(.svg-pan-zoom_viewport))')

                // if has child of zoom_group  and not zoom_group svg-pan-zoom_viewport then proceed for each? This seems surprisingly reasonable.

                for (var i = 0; svgChildren && i < svgChildren.length; i++) {
                    var svgElement = svgChildren[i];
                    this.svgSetup(svgElement);
                }
            });
        }
    };
</script>

<style>
    .preview-pane > div.preview-wrap {
        margin: auto;
        max-width: 400px;
    }

    .preview-pane div.svg-wrap {
        height: 400px;
        width: 400px;
        position: relative;
        text-align: center;
    }

    .preview-pane div.preview-panel {
        background: #fff;
        border: #c51730 1px solid;
    }

    .flex-even {
        flex: 1;
    }

    .flex-wrap {
        flex-wrap: wrap;
    }

    .preview-pane svg {
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        overflow: hidden;
    }

    .svg-wrap .pin_hover {
        fill: gold !important;
        stroke: gold !important;
    }

    .svg-wrap .mechanical_pin_hover {
        fill: gold !important;
        stroke: gold !important;
    }

    @media (min-width: 1300px ) {
        .nav {
            display: none;
        }
    }

    @media (max-width: 1299.9px ) {
        .preview-pane:not(.active), .preview-title {
            display: none;
        }

        .nav {
            display: -ms-flexbox !important;
            display: -webkit-box !important;
            display: flex !important;
        }
    }

    @media (max-width: 434.9px ) {
        .preview-pane > div.preview-wrap {
            max-width: 350px;
        }

        .preview-pane .svg-wrap {
            height: 350px;
            width: 350px;
        }
    }
</style>